import React from 'react'

const ToggleSwitch = ({
  id,
  checked = false,
  onChange,
  label,
  description,
  disabled = false,
  compact = false,
  className = '',
}) => {
  const handleToggle = () => {
    if (disabled || !onChange) return
    onChange(!checked)
  }

  const sizeClasses = compact
    ? {
        container: 'w-10 h-5',
        circle: 'w-4 h-4',
        translate: checked ? 'translate-x-5' : 'translate-x-1',
      }
    : {
        container: 'w-14 h-7',
        circle: 'w-6 h-6',
        translate: checked ? 'translate-x-7' : 'translate-x-1',
      }

  const showText = !!label || !!description

  return (
    <div className={`flex items-start justify-between ${className}`}>
      {showText && (
        <div className="pr-4">
          {label && (
            <label
              htmlFor={id}
              className="block text-sm font-medium text-gray-700"
            >
              {label}
            </label>
          )}
          {description && (
            <p className="text-sm text-gray-500 mt-1">{description}</p>
          )}
        </div>
      )}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        id={id}
        onClick={handleToggle}
        disabled={disabled}
        className={`
          relative inline-flex flex-shrink-0 ${sizeClasses.container}
          border-2 border-transparent rounded-full cursor-pointer
          transition-colors ease-in-out duration-200
          ${checked ? 'bg-blue-600' : 'bg-gray-200'}
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
      >
        <span
          className={`
            pointer-events-none inline-block ${sizeClasses.circle}
            rounded-full bg-white shadow transform ring-0 transition duration-200
            ${sizeClasses.translate}
          `}
        />
        <span className="sr-only">{label || 'Toggle'}</span>
      </button>
    </div>
  )
}

export default ToggleSwitch
